import { eObjectSelectors } from '../../object/object.slice';
import { createMapStateToPropDecorator } from '../../store.decorators';
import { metadataSelectors } from '../metadata/metadata.slice';
import { fieldSelectors } from './field.slice';

export const Field = createMapStateToPropDecorator<void>(function (state, propName) {
  if (this.fieldPath) {
    const field = fieldSelectors.selectById(state, this.fieldPath);
    if (field) {
      return { [propName]: field };
    }
  }
}, 'fieldPath');

export const FieldValue = createMapStateToPropDecorator<void>(function (state, propName) {
  if (this.valuePath && eObjectSelectors.hasPath(state, this.valuePath)) {
    const value = eObjectSelectors.getValue(state, this.valuePath);
    return { [propName]: value };
  }
}, 'valuePath');

export const AdvancedFields = createMapStateToPropDecorator<string>(function (state, propName) {
  if (this.metadataPath) {
    return { [propName]: metadataSelectors.getAdvancedFieldsByMetadata(state, this.metadataPath, this.filteredField?.fieldPath) };
  }
}, 'metadataPath');

export const CommonFields = createMapStateToPropDecorator<string>(function (state, propName) {
  if (this.metadataPath) {
    return { [propName]: metadataSelectors.getCommonFieldsByMetadata(state, this.metadataPath, this.filteredField?.fieldPath) };
  }
}, 'metadataPath');
